import { ShiftModel } from '@/libs/Api';
import { graphqlPost } from '@/libs/tpm-analytics/graphql/transport';
import { buildShiftsQuery } from '@/libs/tpm-analytics/graphql/queries';
import { toIsoString } from '@/libs/tpm-analytics/graphql/queries';

/**
 * Repository responsible for reading shift data from GraphQL.
 * Only data access lives here; no business logic.
 */
export class ShiftsRepository {
    /**
     * Fetch shifts in a time range. Optional server-side filters are translated to GraphQL where clause.
     */
    static async fetchShiftsForRange(
        _predicates: any[],
        fromIso?: string,
        toIso?: string,
        filters?: { locationIds?: string[]; workplaceIds?: string[]; projectIds?: string[]; shiftTypeIds?: string[]; shiftTeamTypeIds?: string[] }
    ): Promise<ShiftModel[]> {
        const listExpr = (ids?: string[]) => (ids && ids.length > 0 ? `[${ids.map((x) => `"${x}"`).join(', ')}]` : '[]');
        const parts: string[] = [
            // overlaps interval: shift.from < to AND shift.to > from
            // Používáme striktní nerovnosti kvůli výrobnímu dni (konec výrobního dne je začátek následujícího)
            `fromDate: { lt: $to }`,
            `toDate: { gt: $from }`,
        ];
        const f = filters || {};
        if (f.workplaceIds && f.workplaceIds.length > 0) parts.push(`workplaceId: { in: ${listExpr(f.workplaceIds)} }`);
        if (f.locationIds && f.locationIds.length > 0) parts.push(`workplace: { locationId: { in: ${listExpr(f.locationIds)} } }`);
        if (f.projectIds && f.projectIds.length > 0) parts.push(`shiftProductions: { some: { projectId: { in: ${listExpr(f.projectIds)} } } }`);
        if (f.shiftTypeIds && f.shiftTypeIds.length > 0) parts.push(`shiftTypeId: { in: ${listExpr(f.shiftTypeIds)} }`);
        if (f.shiftTeamTypeIds && f.shiftTeamTypeIds.length > 0) parts.push(`shiftTeamTypeId: { in: ${listExpr(f.shiftTeamTypeIds)} }`);
        const where = `{ ${parts.join(', ')} }`;
        const query = buildShiftsQuery(where);
        if ((window as any).__TPM_GQL_DEBUG) {
            // eslint-disable-next-line no-console
            console.log('[TPM][Repo][Shifts] fetchShiftsForRange', { from: fromIso, to: toIso, filters });
        }
        const data = await graphqlPost<any>(query, { from: toIsoString(fromIso), to: toIsoString(toIso) });
        const list = data?.shifts ?? [];
        return Array.isArray(list) ? (list as ShiftModel[]) : [];
    }
}


